import { render } from "./KanuContainer.vue?vue&type=template&id=db8bb32e&scoped=true"
import script from "./KanuContainer.vue?vue&type=script&lang=js"
export * from "./KanuContainer.vue?vue&type=script&lang=js"

import "./KanuContainer.vue?vue&type=style&index=0&id=db8bb32e&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/futurefest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8bb32e"]])

export default __exports__